import { render, staticRenderFns } from "./orderdeal.vue?vue&type=template&id=2aeb099b&scoped=true&"
import script from "./orderdeal.vue?vue&type=script&lang=js&"
export * from "./orderdeal.vue?vue&type=script&lang=js&"
import style1 from "./orderdeal.vue?vue&type=style&index=1&id=2aeb099b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb099b",
  null
  
)

export default component.exports